import { api } from '@/modules/api'
import saveFileFromBase64 from '@/utils/saveFileFromBase64'

const actions = {
  async downloadExcel ({ commit }, field) {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.excel.downloadExcel(field),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'Items', 'xlsx')
    } catch (err) {
      throw err
    }
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/importExcel.js